import(/* webpackMode: "eager" */ "/app/src/app/tin-tuc/[post]/page.js");
